import { createContext, useContext, useState, useCallback } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Check, AlertCircle } from 'lucide-react';
import { ToastContainer, ToastItem, ToastIcon } from './Toast.styles';

const ToastContext = createContext(null);

export function useToast() {
  return useContext(ToastContext);
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'success') => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 3000);
  }, []);

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <ToastContainer>
        <AnimatePresence>
          {toasts.map((t) => (
            <ToastItem
              key={t.id}
              $type={t.type}
              initial={{ opacity: 0, x: 60 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 60 }}
              transition={{ duration: 0.25 }}
            >
              <ToastIcon $type={t.type}>
                {t.type === 'error' ? <AlertCircle size={16} /> : <Check size={16} />}
              </ToastIcon>
              {t.message}
            </ToastItem>
          ))}
        </AnimatePresence>
      </ToastContainer>
    </ToastContext.Provider>
  );
}
